import { TraceService, createErrorHandler } from '@sentry/angular';
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { Router, provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { routes } from './app.routes';
import { UserProfileService } from './services/user-profile.service';
import { PAGE_MENU_STATE, USER_PROFILE_LOADER } from 'ngx-register-base';
import { MenuStateService } from './services/menu-state.service';
import { prizmIconsProvideOldNameTransformer } from '@prizm-ui/icons';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideEventPlugins } from '@taiga-ui/event-plugins';
import { TUI_LANGUAGE, TUI_RUSSIAN_LANGUAGE } from '@taiga-ui/i18n';
import { of } from 'rxjs';
import { environment } from '../environments/environment';
import { initKeycloak } from './utils/keycloak-init.factory';
// eslint-disable-next-line sonarjs/deprecation
import { KeycloakAngularModule } from 'keycloak-angular';
import { tuiHintOptionsProvider } from '@taiga-ui/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initKeycloak(inject(UserProfileService));
      return initializerFn();
    }),
    provideRouter(routes),
    provideAnimations(),
    provideEventPlugins(),
    // eslint-disable-next-line sonarjs/deprecation
    importProvidersFrom(KeycloakAngularModule),
    provideHttpClient(withInterceptorsFromDi()),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      return {
        link: httpLink.create({ uri: environment.api.graphql }),
        cache: new InMemoryCache(),
      };
    }),
    { provide: USER_PROFILE_LOADER, useExisting: UserProfileService },
    { provide: PAGE_MENU_STATE, useExisting: MenuStateService },
    { provide: TUI_LANGUAGE, useValue: of(TUI_RUSSIAN_LANGUAGE) },
    prizmIconsProvideOldNameTransformer(),
    {
      provide: ErrorHandler,
      useValue: createErrorHandler(),
    },
    {
      provide: TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
    tuiHintOptionsProvider({
      appearance: 'dark',
    }),
  ],
};
